import { AccountTransactionList } from "../tlSalesOnAccount";

const TLPaymentVoucher = () => <AccountTransactionList
  title="Payment Voucher"
  moduleId="ACTPVC"
  storageKey="paymentVoucher.filters"
  accessPath="/api/payment-voucher/access"
  statusPath="/api/payment-voucher/status"
  printPath="/api/payment-voucher/print"
  print2307Path="/api/payment-voucher/print-2307"
  modifyPaymentPath="/api/payment-voucher/modify-payment"
  validateDataPath="/api/payment-voucher/validate-data"
  printSvccPath="/api/payment-voucher/print-svcc"
  setBranchPath="/api/payment-voucher/assignment"
  linkProjectPath="/api/payment-voucher/assignment"
  transactionPath="/App/PaymentVoucherTransaction"
  documentPrefix="PV"
  rowClassPrefix="pv"
  centeredErrors
  hideUnauthorizedActions
/>;

export default TLPaymentVoucher;
